
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Comment définir l'objectif de son site internet ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Avoir un site internet est devenu indispensable pour les entreprises et les particuliers cherchant à établir leur présence en ligne et à atteindre leurs objectifs commerciaux.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Comment définir l'objectif de son site internet ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Avoir un site internet est devenu indispensable pour les entreprises et les particuliers cherchant à établir leur présence en ligne et à atteindre leurs objectifs commerciaux.",
        },
      ],
    };
  },
};
